export default __webpack_public_path__ + "static/media/Person-1.2062b061.png";